<template>
  <div class="employee-ack-preview-skeleton d-flex flex-column ga-6">
    <section class="employee-ack-preview-skel-header">
      <v-skeleton-loader
        type="heading"
        width="60%"
        class="mb-2 employee-ack-preview-skel-title"
      />
      <v-skeleton-loader
        type="text"
        width="45%"
        class="employee-ack-preview-skel-line"
      />
    </section>

    <section class="employee-ack-preview-skel-position">
      <v-skeleton-loader
        type="heading"
        width="50%"
        class="mb-3 employee-ack-preview-skel-section-title"
      />
      <div class="employee-ack-preview-skel-grid">
        <template
          v-for="i in metadataRowCount"
          :key="i"
        >
          <v-skeleton-loader
            type="text"
            width="110"
            class="employee-ack-preview-skel-line"
          />
          <v-skeleton-loader
            type="text"
            :width="metadataValueWidth(i)"
            class="employee-ack-preview-skel-line"
          />
        </template>
      </div>
    </section>

    <section class="employee-ack-preview-skel-card">
      <v-skeleton-loader
        type="text"
        width="100%"
        height="100"
        class="employee-ack-preview-skel-card-block"
      />
    </section>
  </div>
</template>

<script setup>
const metadataRowCount = 3;

const metadataValueWidth = (index) => {
  const widths = ['70%', '55%', '65%'];

  return widths[index - 1] ?? '60%';
};
</script>

<style scoped lang="less">
:deep(.v-skeleton-loader .v-skeleton-loader__heading),
:deep(.v-skeleton-loader .v-skeleton-loader__text) {
  background: @bg-canvas;
}

.employee-ack-preview-skel-grid {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 10px;
  align-items: center;
}

.employee-ack-preview-skel-title :deep(.v-skeleton-loader__heading),
.employee-ack-preview-skel-section-title :deep(.v-skeleton-loader__heading) {
  height: 28px;
}

.employee-ack-preview-skel-line :deep(.v-skeleton-loader__text) {
  height: 16px;
  border-radius: 6px;
}

.employee-ack-preview-skel-card-block :deep(.v-skeleton-loader__text) {
  height: 100px;
  border-radius: 8px;
}
</style>
